/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');

var DepEnforcementProvisionsSectionView = require('../views/DepEnforcementProvisionsSectionView');
var PlaceholderView = require('common/views/PlaceholderView');

var GetProvisionByEnforcement = require('../services/GetProvisionByEnforcement');

module.exports = {
  channel: 'dp',

  event: 'build:enforcement-provision-section-view',

  builder: function(enforcementActionId) {
    return new PlaceholderView({
      viewPromise: buildEnforcementProvisionsSectionView(enforcementActionId)
    });
  }
};

function buildEnforcementProvisionsSectionView(enforcementActionId) {
  var deferred = $.Deferred();
  GetProvisionByEnforcement(enforcementActionId)
    .done(function(provisions) {
      deferred.resolve(
        new DepEnforcementProvisionsSectionView({
          collection: new PageableCollection(provisions, { pageSize: 25 })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
